(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cloudless-announcement"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-cloudless-announcement]').forEach((bar) => {
        if (bar.dataset.cloudlessMounted === 'true') return;
        bar.dataset.cloudlessMounted = 'true';
        const messages = [...bar.querySelectorAll('[data-cloudless-announcement-message]')];
        const interval = Number(bar.dataset.interval || 0);
        let index = 0;
        let timer;
        const show = (nextIndex) => {
          index = (nextIndex + messages.length) % messages.length;
          messages.forEach((message, messageIndex) => {
            const selected = messageIndex === index;
            message.hidden = !selected;
            message.classList.toggle('is-selected', selected);
          });
        };
        bar.cloudlessShow = show;
        if (messages.length < 2 || interval < 1000) return;
        const play = () => {
          window.clearInterval(timer);
          timer = window.setInterval(() => show(index + 1), interval);
          bar.cloudlessTimer = timer;
        };
        bar.addEventListener('mouseenter', () => window.clearInterval(timer));
        bar.addEventListener('mouseleave', play);
        bar.addEventListener('focusin', () => window.clearInterval(timer));
        bar.addEventListener('focusout', play);
        play();
      });
      document.querySelectorAll('.shopify-section--announcement-bar').forEach((section) => {
        document.documentElement.style.setProperty('--announcement-bar-height', `${Math.round(section.clientHeight)}px`);
      });
    };
    mount();
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-cloudless-announcement]').forEach((bar) => {
        window.clearInterval(bar.cloudlessTimer);
        delete bar.dataset.cloudlessAnnouncementMounted;
        delete bar.cloudlessTimer;
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const message = event.target.closest('[data-cloudless-announcement-message]');
      const bar = message?.closest('[data-cloudless-announcement]');
      if (!message || !bar?.cloudlessShow) return;
      const messages = [...bar.querySelectorAll('[data-cloudless-announcement-message]')];
      bar.cloudlessShow(messages.indexOf(message));
    });
    window.addEventListener('resize', () => mount());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-footer-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-cloudless-footer-shell]').forEach((footer) => {
        if (footer.dataset.cloudlessFooterMounted === 'true') return;
        footer.dataset.cloudlessFooterMounted = 'true';
        const controller = new AbortController();
        footer.cloudlessAbortController = controller;
        const signal = controller.signal;
        const closeAll = () => {
          footer.querySelectorAll('[data-cloudless-footer-popover]').forEach((popover) => { popover.hidden = true; });
          footer.querySelectorAll('[data-cloudless-footer-popover-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        };
        footer.querySelectorAll('[data-cloudless-footer-popover-trigger]').forEach((trigger) => {
          const popover = footer.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
          trigger.addEventListener('click', () => {
            const opening = popover?.hidden;
            closeAll();
            if (popover) popover.hidden = !opening;
            trigger.setAttribute('aria-expanded', String(opening));
          }, { signal });
        });
        document.addEventListener('click', (event) => { if (!footer.contains(event.target)) closeAll(); }, { signal });
        document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); }, { signal });
      });
    };
    mount();
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const footer = event.target.querySelector('[data-cloudless-footer-shell]');
      footer?.cloudlessAbortController?.abort();
      if (footer) {
        delete footer.dataset.cloudlessFooterMounted;
        delete footer.cloudlessAbortController;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloudless-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mount = (scope = document) => {
      scope.querySelectorAll('[data-cloudless-header-shell]').forEach((header) => {
        if (header.dataset.cloudlessHeaderMounted === 'true') return;
        header.dataset.cloudlessHeaderMounted = 'true';
        const controller = new AbortController();
        header.cloudlessAbortController = controller;
        const signal = controller.signal;
        const toggle = header.querySelector('[data-cloudless-menu-toggle]');
        const closeButton = header.querySelector('[data-cloudless-menu-close]');
        const panel = header.querySelector('[data-cloudless-mobile-menu]');
        let lastY = window.scrollY;
        let returnFocus;
        const updateMobileMenuOffset = () => {
          if (!panel) return;
          // The fixed drawer is inside Horizon's transformed/sticky header,
          // so its inset is relative to that containing block. Use the header
          // height; adding the document-space top would count the announcement
          // bar twice and leave a 40px gap.
          const top = Math.max(0, Math.round(header.getBoundingClientRect().height));
          panel.style.setProperty('--cloudless-mobile-menu-top', `${top}px`);
        };
        const closeMenu = () => {
          panel?.classList.remove('is-open');
          panel?.setAttribute('aria-hidden', 'true');
          toggle?.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('lock');
          returnFocus?.focus();
        };
        const openMenu = (moveFocus = true) => {
          if (moveFocus) returnFocus = document.activeElement;
          updateMobileMenuOffset();
          panel?.classList.add('is-open');
          panel?.setAttribute('aria-hidden', 'false');
          toggle?.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('lock');
          if (moveFocus) panel?.querySelector('button, a, select')?.focus();
        };
        toggle?.addEventListener('click', () => panel?.classList.contains('is-open') ? closeMenu() : openMenu(), { signal });
        closeButton?.addEventListener('click', closeMenu, { signal });
        panel?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu, { signal }));

        const promo = header.querySelector('[data-cloudless-mobile-promo]');
        const promoCarousel = promo?.querySelector('[data-cloudless-promo-carousel]');
        const promoPrev = promo?.querySelector('[data-cloudless-promo-prev]');
        const promoNext = promo?.querySelector('[data-cloudless-promo-next]');
        const promoPrevButton = promoPrev?.querySelector('button');
        const promoNextButton = promoNext?.querySelector('button');
        const promoSlides = promoCarousel ? [...promoCarousel.querySelectorAll('[data-cloudless-promo-slide]')] : [];
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        let promoFrame;
        const updatePromoControls = () => {
          if (!promo || !promoCarousel || !promoPrevButton || !promoNextButton) return;
          const maximum = Math.max(0, promoCarousel.scrollWidth - promoCarousel.clientWidth);
          const position = Math.abs(promoCarousel.scrollLeft);
          const scrollable = maximum > 2;
          const activeIndex = promoSlides.reduce((nearest, slide, index) => {
            const target = Math.abs(slide.offsetLeft - promoCarousel.offsetLeft);
            return Math.abs(target - position) < nearest.distance
              ? { index, distance: Math.abs(target - position) }
              : nearest;
          }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
          promo.classList.toggle('is-scrollable', scrollable);
          promoCarousel.classList.toggle('is-scrollable', scrollable);
          promoPrev.hidden = !scrollable;
          promoNext.hidden = !scrollable;
          promoPrevButton.disabled = !scrollable || activeIndex === 0;
          promoNextButton.disabled = !scrollable || activeIndex === promoSlides.length - 1 || position >= maximum - 2;
        };
        const queuePromoUpdate = () => {
          cancelAnimationFrame(promoFrame);
          promoFrame = requestAnimationFrame(updatePromoControls);
        };
        const scrollPromo = (direction) => {
          if (!promoCarousel || promoSlides.length === 0) return;
          const styles = getComputedStyle(promoCarousel);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = promoSlides[0].getBoundingClientRect().width + gap;
          promoCarousel.scrollBy({ left: distance * direction, behavior: reduceMotion ? 'auto' : 'smooth' });
        };
        promoPrevButton?.addEventListener('click', () => scrollPromo(-1), { signal });
        promoNextButton?.addEventListener('click', () => scrollPromo(1), { signal });
        promoCarousel?.addEventListener('scroll', queuePromoUpdate, { passive: true, signal });
        if (promoCarousel && 'ResizeObserver' in window) {
          const promoObserver = new ResizeObserver(queuePromoUpdate);
          promoObserver.observe(promoCarousel);
          signal.addEventListener('abort', () => promoObserver.disconnect(), { once: true });
        }
        queuePromoUpdate();

        document.addEventListener('shopify:block:select', (event) => {
          if (!promoCarousel) return;
          const selectedId = event.detail?.blockId || event.target.closest?.('[data-cloudless-promo-slide]')?.dataset.cloudlessBlockId;
          if (!selectedId) return;
          const selectedSlide = promoCarousel.querySelector(`[data-cloudless-block-id="${CSS.escape(selectedId)}"]`);
          if (!selectedSlide) return;
          if (window.matchMedia('(max-width: 999px)').matches) openMenu(false);
          requestAnimationFrame(() => {
            promoCarousel.scrollTo({ left: selectedSlide.offsetLeft - promoCarousel.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
            queuePromoUpdate();
          });
        }, { signal });

        const megaTrigger = header.querySelector('[data-cloudless-mega-trigger]');
        const megaPanel = header.querySelector('[data-cloudless-mega-panel]');
        const setMega = (open) => {
          if (!megaTrigger || !megaPanel) return;
          megaPanel.hidden = !open;
          megaTrigger.setAttribute('aria-expanded', String(open));
        };
        megaTrigger?.addEventListener('click', (event) => {
          if (megaPanel?.hidden) {
            event.preventDefault();
            setMega(true);
          }
        }, { signal });
        megaTrigger?.parentElement?.addEventListener('mouseenter', () => setMega(true), { signal });
        megaTrigger?.parentElement?.addEventListener('mouseleave', () => setMega(false), { signal });
        megaTrigger?.parentElement?.addEventListener('focusout', (event) => {
          if (!megaTrigger.parentElement.contains(event.relatedTarget)) setMega(false);
        }, { signal });

        header.querySelectorAll('[data-cloudless-popover-trigger]').forEach((trigger) => {
          const popover = header.querySelector(`#${CSS.escape(trigger.getAttribute('aria-controls'))}`);
          trigger.addEventListener('click', () => {
            const opening = popover?.hidden;
            header.querySelectorAll('[data-cloudless-popover]').forEach((item) => { item.hidden = true; });
            header.querySelectorAll('[data-cloudless-popover-trigger]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
            if (popover) popover.hidden = !opening;
            trigger.setAttribute('aria-expanded', String(opening));
          }, { signal });
        });

        document.addEventListener('click', (event) => {
          if (!event.target.closest('.cloudless-localization')) {
            header.querySelectorAll('[data-cloudless-popover]').forEach((item) => { item.hidden = true; });
            header.querySelectorAll('[data-cloudless-popover-trigger]').forEach((item) => item.setAttribute('aria-expanded', 'false'));
          }
        }, { signal });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Tab' && panel?.classList.contains('is-open')) {
            const focusable = [...panel.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), input:not([disabled])')]
              .filter((item) => !item.hidden && item.getClientRects().length > 0);
            if (focusable.length > 0) {
              const first = focusable[0];
              const last = focusable[focusable.length - 1];
              if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
              } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
              }
            }
          }
          if (event.key === 'Escape') {
            closeMenu();
            setMega(false);
            header.querySelectorAll('[data-cloudless-popover]').forEach((item) => { item.hidden = true; });
          }
        }, { signal });
        window.addEventListener('resize', updateMobileMenuOffset, { passive: true, signal });
        window.addEventListener('scroll', () => {
          if (panel?.classList.contains('is-open')) {
            updateMobileMenuOffset();
            return;
          }
          if (!header.classList.contains('cloudless-header--hide-on-scroll')) return;
          const currentY = window.scrollY;
          if (Math.abs(currentY - lastY) > 8) header.style.transform = currentY > lastY && currentY > 100 ? 'translateY(-110%)' : '';
          lastY = currentY;
        }, { passive: true, signal });
        updateMobileMenuOffset();
      });
      const header = document.querySelector('[data-cloudless-header-shell]');
      if (header) document.body.style.setProperty('--header-height', `${Math.round(header.getBoundingClientRect().height)}px`);
    };
    mount();
    document.addEventListener('shopify:section:load', (event) => mount(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const header = event.target.querySelector('[data-cloudless-header-shell]');
      header?.cloudlessAbortController?.abort();
      if (header) {
        delete header.dataset.cloudlessHeaderMounted;
        delete header.cloudlessAbortController;
      }
    });
    document.addEventListener('shopify:block:select', (event) => {
      const header = event.target.closest('[data-cloudless-header-shell]');
      if (!header) return;
      const trigger = header.querySelector('[data-cloudless-mega-trigger]');
      const panel = header.querySelector('[data-cloudless-mega-panel]');
      if (trigger && panel && event.target.closest('[data-cloudless-mega-panel] .mega-menu-glass__item')) {
        panel.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
    window.addEventListener('resize', () => mount());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
